import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const HeartIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5 1.36526C2.79086 1.36526 1 3.16341 1 5.38155C1 9.08607 4.81147 13.064 6.80945 14.8947C7.49163 15.5198 8.50837 15.5198 9.19055 14.8947C11.1885 13.064 15 9.08607 15 5.38155C15 3.16341 13.2091 1.36526 11 1.36526C9.80531 1.36526 8.73295 1.89115 8 2.72495C7.26706 1.89115 6.19469 1.36526 5 1.36526Z"
		/>
	</svg>
))
